import { useEffect } from 'react';
// utils
import Intercom from '@intercom/messenger-js-sdk';
import { useLocation } from 'react-router-dom';
import { useProfileQuery } from '@/services/customer/profile/profile.queries';
import { useAccountQuery } from '@/services/customer/account/account.queries';
import { PATHS } from '@/constants';

const Widget = () => {
    const location = useLocation();
    const isCreatePartnerPage = location.pathname.includes(PATHS.createPartner);
    const { data: profile } = useProfileQuery(!isCreatePartnerPage);
    const { data: account } = useAccountQuery(!isCreatePartnerPage);
    useEffect(() => {
        if (profile && account) {
            Intercom({
                app_id: import.meta.env.VITE_INTERCOM_APP_ID,
                user_id: account.id,
                name: account.name,
                email: account.email,
                customer_idn: profile.idn,
                hide_default_launcher: false
            });
        }
    }, [profile, account]);
    return <div />;
};

export default Widget;
